import { render } from "./FoodTemperature.vue?vue&type=template&id=7ff5e21f"
import script from "./FoodTemperature.vue?vue&type=script&lang=js"
export * from "./FoodTemperature.vue?vue&type=script&lang=js"

import "./FoodTemperature.vue?vue&type=style&index=0&id=7ff5e21f&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__